import app from 'flarum/forum/app';
import Component from "flarum/common/Component";
import Link from "flarum/common/components/Link";
import avatar from "flarum/common/helpers/avatar";
import username from "flarum/common/helpers/username";
export default class MoneyLeaderboardListItem extends Component {
  view() {
    const {
      leaderboardListItem,
      rankID
    } = this.attrs;
    const moneyName = '[money] 积分';
    const moneyValue = leaderboardListItem.attribute("leaderboardMoney");
    const moneyText = app.forum.attribute('moneyLeaderBoardHideMoneyText') === "1" ? moneyValue : moneyName.replace('[money]', moneyValue);
    let trophyClass = "MoneyLeaderboardListItemTrophyNone";
    let rankClass = "MoneyLeaderboardListItemRankTop";
    if (rankID === 1) {
      trophyClass = "MoneyLeaderboardListItemTrophyGold";
    } else if (rankID === 2) {
      trophyClass = "MoneyLeaderboardListItemTrophySilver";
    } else if (rankID === 3) {
      trophyClass = "MoneyLeaderboardListItemTrophyBronze";
    } else {
      rankClass = "MoneyLeaderboardListItemRankLower";
    }
    return m("div", {
      className: "MoneyLeaderboardListItemContainer"
    }, m("div", {
      class: "MoneyLeaderboardListHeaderRank"
    }, m("div", {
      class: rankClass
    }, rankID), m("div", {
      class: trophyClass
    }, m("i", {
      class: "fas fa-trophy"
    }))), m("div", {
      class: "MoneyLeaderboardListHeaderUser"
    }, m(Link, {
      href: app.route.user(leaderboardListItem),
      className: "transferHistoryUser",
      style: "color:var(--heading-color)"
    }, avatar(leaderboardListItem), username(leaderboardListItem))), m("div", {
      class: "MoneyLeaderboardListHeaderMoney"
    }, moneyText));
  }
}
flarum.reg.add('ziiven-money-leaderboard', 'forum/components/MoneyLeaderboardListItem', MoneyLeaderboardListItem);